$(document).ready(function() {
  $(document).on('click', '.brands-confirmation-day-tracker-component .advisor-info', function() {
    const clients = $(this).closest('.advisor').find('.clients')
    if (clients.hasClass('d-none')) {
      clients.removeClass('d-none')
    } else {
      clients.addClass('d-none')
    }
  })

  $(document).on('click', '.brands-confirmation-day-tracker-component .brand-card__header', function() {
    const advisors = $(this).closest('.brand-card').find('.brand-card__advisors')
    if (advisors.hasClass('d-none')) {
      advisors.removeClass('d-none')
    } else {
      advisors.addClass('d-none')
    }
  })

  $(document).on('click', '#confirmation-day-page .expand-collapse-all--js', function() {
    const button = $(this)
    const buttonText = $(this).text()
    const brandCards = $(this).closest('#confirmation-day-page').find('.component .brand-card.expandable')

    brandCards.each (function() {
      const brandCard = $(this)
      const brandCardAdvisors = brandCard.find('.brand-card__advisors')
      const brandCardClients = brandCardAdvisors.find('.clients')

      if (buttonText === 'Expand All') {
        brandCardAdvisors.removeClass('d-none')
        brandCardClients.removeClass('d-none')
        button.text('Collapse All')
      } else {
        brandCardAdvisors.addClass('d-none')
        brandCardClients.addClass('d-none')
        button.text('Expand All')
      }
    })
  })
})